// Retorna o peso correspondente à Unidade = 1
export function getPesoPeca(produto) {
  return Number(
    produto.correspondencias?.find(
      (c) => Number(c.Unidade) === 1
    )?.corresp ?? produto.pesoPeca ?? 0
  );
}

// Retorna o peso correspondente à Unidade = 2
export function getPesoCaixa(produto) {
  return Number(
    produto.correspondencias?.find(
      (c) => Number(c.Unidade) === 2
    )?.corresp ?? produto.pesoCaixa ?? 0
  );
}

// Grupo 60 = venda por caixa
export function ehCaixa(produto) {
  return Boolean(
    produto.ehCaixa ??
    (Number(produto.codgrupo) === 60)
  );
}

// Produto vendido por peça com preço por kg
export function ehPesoPorPeca(produto) {
  return Boolean(
    produto.ehPesoPorPeca ??
    (
      !ehCaixa(produto) &&
      Number(produto.corrigepreco) === 1 &&
      getPesoPeca(produto) > 0
    )
  );
}

// Multiplicador utilizado nos cálculos
export function getMultiplicadorVenda(produto) {

  if (ehCaixa(produto)) {
    return getPesoCaixa(produto);
  }

  if (ehPesoPorPeca(produto)) {
    return getPesoPeca(produto);
  }

  return 1;

}